<template>
    <div class="container container--echeancier">  

        <Loader v-if="!ready"></Loader>

        <article class="echeancier" v-if="ready">

            <header class="echeancier__heading">
                <h1 class="woocommerce-order-details__title">{{ title }}</h1>
                <div class="echeancier__heading__date">
                    <p>
                        <strong>Émis le <Date :date="echeancier.createdAt" /></strong> 
                        &nbsp;<Badge type="warning" v-if="echeancier.isAcquittee">Acquitté</Badge>
                        &nbsp;<Badge type="warning" v-if="!echeancier.isAcquittee">En attente</Badge>
                        &nbsp;<Badge type="danger" v-if="!echeancier.isAcquittee && echeancier.isExpired">En retard de paiement</Badge>
                    </p>
                </div>
                <div class="devis__heading__actions">
                    <button class="woocommerce-button button alt"
                        type="button"
                        v-if="!echeancier.isAcquitte"
                        @click="pay()">Payer</button>
                </div>
            </header>         
            
            <div class="echeancier__details">
                <ul class="woocommerce-order-overview woocommerce-thankyou-order-details order_details">
                    <li class="woocommerce-order-overview__order order" v-if="!echeancier.isAvoir">Références :
                        <strong>
                            <router-link
                                :to="{ name: 'facture', params: { id: echeancier.facture.id }}">Facture n°{{ echeancier.facture.num }}</router-link>
                        </strong>
                    </li>
                    <li class="woocommerce-order-overview__order order">Échéance le : <strong><Date :date="echeancier.expiredAt" /></strong></li>
                    <li class="woocommerce-order-overview__order order">Montant HT: <strong><Price :amount="echeancier.amountHT" :currency="echeancier.currency" /></strong></li>
                    <li class="woocommerce-order-overview__order order">Montant TTC: <strong><Price :amount="echeancier.amountTTC" :currency="echeancier.currency" /></strong></li>
                    <li class="woocommerce-order-overview__order order">Montant TTC restant: <strong><Price :amount="echeancier.amountRemaining" :currency="echeancier.currency" /></strong></li>
                    <li class="woocommerce-order-overview__order order">Montant TTC échu: <strong><Price :amount="echeancier.amountExpired" :currency="echeancier.currency" /></strong></li>
                </ul>
            </div>  

        </article>

    </div>
</template>

<script>
import { mapState } from 'vuex'

import { goTo } from '@/router'
import { actions } from '@/store/echeanciers'

import title from "@/containers/title"

import Badge from '@/components/badge/Badge.vue'
import Date from '@/components/date/Date.vue'
import Loader from '@/components/loader/Loader.vue'
import Price from '@/components/price/Price.vue'

export default {

    name: 'Facture',

    computed: mapState({

        echeancier: state => state.echeanciers.current,

        ready: state => ( state.echeanciers.current !== null ),

        title: state => {
            return ( ( state.echeanciers.current.isAvoir ) ? 'Avoir ' : 'Échéance ' ) + state.echeanciers.current.num
        }

    }),

    methods: {

        pay: function() {
            goTo('/wp-content/plugins/myAdelya/tasks/purchase/echeanciers/' + this.echeancier.id)
        }
    },
  
    created () {
        this.$store.dispatch(actions.GET, this.$route.params.id)
            .then( () => this.setTitle( this.title ) )
            .catch(error => {
                this.$errorPage(error.reason)
            })
    },

    components: {
        Badge,
        Date,
        Loader,
        Price
    },

    mixins: [ title ]
}
</script>

<style>

.echeancier {
    position: relative;
}

.echeancier__heading {
    margin-bottom: 2rem;
    padding-top: 4rem; 
}

.echeancier__heading__actions {
    position: absolute;
    right: 0;
    top: 0;
}

.echeancier__heading__actions > *:not(:first-child) {
    margin-left: 1rem !important;
}

.echeancier__footer {
}

.echeancier__footer__actions {
    text-align: right;
}

</style>
